import { IntegrationsDisconnectDialog } from "@components/integrations-dialog/integrations-disconnect-dialog";
import { IntegrationsInProgressDialog } from "@components/integrations-dialog/integrations-in-progress-dialog";
import { IntegrationsSuccessfulDialog } from "@components/integrations-dialog/integrations-successful-dialog";
import {
  IntegrationDialogCallbacks,
  UserLevelIntegrationDialog,
} from "@custom-types/integrations-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props extends IntegrationDialogCallbacks {
  /** Integration ID */
  integrationId: FaroCoreApiTypes.IntegrationId;

  /** Dialog state */
  dialogState: UserLevelIntegrationDialog;
}

/** All the dialogs for integrations process */
export function IntegrationDialog({
  integrationId,
  dialogState,
  onSuccessDialogConfirm,
  onInProgressDialogCancel,
  onDisconnectDialogConfirm,
  onDisconnectDialogCancel,
}: Props): JSX.Element | null {
  switch (dialogState) {
    case "inProgress":
      return (
        <IntegrationsInProgressDialog
          integrationId={integrationId}
          dialogCancelCallback={onInProgressDialogCancel}
        />
      );

    case "disconnect":
      return (
        <IntegrationsDisconnectDialog
          dialogConfirmCallback={onDisconnectDialogConfirm}
          dialogCancelCallback={onDisconnectDialogCancel}
          integrationId={integrationId}
        />
      );

    case "success":
      return (
        <IntegrationsSuccessfulDialog
          integrationId={integrationId}
          dialogConfirmCallback={onSuccessDialogConfirm}
        />
      );
    case "none":
      return null;
  }
}
